import _cloneDeep from 'lodash.clonedeep'

import types from './types'
import { createReducer, updateState } from 'redux/handlers'

const initialState = {
  thread: {},
  drafts: {
    count: 0,
    data: [],
  },
  scheduled: {
    count: 0,
    data: [],
    page: 0,
    limit: 50,
    isAll: false,
    messageToEdit: {},
    loading: false,
    deleting: false
  },
  saved: {},
  pinned: {},
  mentions: 0,
  channel: {
    page: 1,
    type: 'channel',
    conversations: [],
    isDefault: true,
    name: "channel",
    orderFilter: "asc",
    sectionId: "",
    showFilter: "all",
    _id:''
  },
  direct: {
    page: 1,
    type: 'direct',
    conversations: [],
    isDefault: true,
    name: "message_direct",
    orderFilter: "asc",
    sectionId: "",
    showFilter: "all",
    _id:'',
  },
  sections: {},
  conversations: {},
  isOpenThreads: false,
  parentId: '',
}

const getDirectConversationsList = (state, action) => {
  const { typeData, conversations, page, data } = action
  if(!state[typeData]){
    const newSections = [...state.sections.conversations]
    const indexSection = newSections.findIndex(section => section._id === data._id)
    newSections[indexSection] = data
    return updateState(state, {
      sections: {
        ...state.sections,
        conversations: [...newSections]
      }
    })
  }
  return updateState(state, { [typeData]: { ...state[typeData], conversations, page }  })
}

const getMainMenuInfo = (state, action) => {
  const { inchat } = action.payload
  return updateState(state, { ...inchat, conversations: { ...state.conversations } })
}

const addConversation = (state, action) => {
  const { conversations } = action
  return updateState(state, { conversations: {
    ...state.conversations,
    [conversations._id]: {
      chat: {
        ...state?.conversations[conversations._id]?.chat,
      },
      composer: {
        ...state.conversations[conversations._id]?.composer || {},
      },
      plugins: {},
      conversation: { ...conversations }
    }
  } })
}

const removeConversation = (state, action) => {
  const { conversationId } = action
  const conversations = Object.assign({}, state.conversations)
  delete conversations[conversationId]
  return updateState(state, { conversations })
}

const removeAllConversation = (state, action) => {
  return updateState(state, { conversations: {} })
}

const updateChatState = (state, action) => {
  const { conversationId, ...rest } = action.payload
  return updateState(state, {
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...state.conversations[conversationId],
        chat: {
          ...state.conversations[conversationId].chat,
          ...rest
        }
      }
    }
  })
}

const setConversationMessages = (state, action) => {
  const { conversationId, messages: newMessages, page } = action.payload
  const conversations = state.conversations
  const messages = page === 1
    ? [...newMessages]
    : conversations[conversationId].chat.messages.concat(newMessages)

  return updateState(state, {
    conversations: {
      ...conversations,
      [conversationId]: {
        ...conversations[conversationId],
        chat: {
          ...conversations[conversationId].chat,
          messages: [...messages],
          page: newMessages.length === 0 ? page - 1 : page,
          allMessagesGetting: newMessages.length === 0,
        }
      }
    }
  })
}

const setThreads = (state, action) => {
  const { conversationId, messages: newMessages, from } = action
  const messages = from === 1
    ? [...newMessages]
    : state.threads[conversationId].messages.concat(newMessages)

  return updateState(state, {
    threads: {
      ...state.threads,
      [conversationId]: {
        ...state.threads[conversationId],
        messages: [...messages],
        from: newMessages.length === 0 ? from - 1 : from,
        allMessagesGetting: newMessages.length === 0,
      },
    }
  })
}

const updateThreadState = (state, action) => {
  const { conversationId, isLoadingMessages } = action
  return updateState(state, {
    threads: {
      ...state.threads,
      [conversationId]: {
        ...state.threads[conversationId],
        isLoadingMessages,
      },
    }
  })
}

const setNewThreadMessage = (state, action) => {
  const { message } = action
  const { threads } = state
  const { conversationId } = message
  let messages = Object.assign([], threads[conversationId]?.messages || [])

  messages.unshift(message)
  return updateState(state, {
    threads: {
      ...state.threads,
      [conversationId]: {
        ...state.threads[conversationId],
        messages: [...messages],
      }
    }
  })
}

const setScheduledMessages = (state, action) => {
  const { messages } = action.payload
  return updateState(state, {
    scheduled: {
      ...state.scheduled,
      count: messages.length,
      data: messages
    }
  })
}

const setScheduledMessageToEdit = (state, action) => {
  return updateState(state, {
    scheduled: {
      ...state.scheduled,
      messageToEdit: { ...action.payload }
    }
  })
}

const updateScheduledMessagesValues = (state, action) => {
  return updateState(state, {
    scheduled: {
      ...state.scheduled,
      ...action.payload
    }
  })
}

const editMessage = (state, action) => {
  const { conversationId, message, draftId, messageId, external = false, parentId } = action
  const { conversations } = state
  let composer = Object.assign({}, conversations[conversationId]?.composer || {})

  composer = {
    ...conversations[conversationId]?.composer || {},
    message: message,
    draftId: composer.draftId ? composer.draftId : draftId,
    parentId,
    external
  }
  if(messageId) composer.messageId = messageId

  const _conversations = {
    ...conversations,
    [conversationId]: {
      ...conversations[conversationId],
      composer,
    }
  }
  return updateState(state, { conversations: _conversations })
}

const updateMessageExternal = (state, action) => {
  const { conversations } = state
  const { external, conversationId } = action.payload
  return updateState(state, { conversations: {
    ...conversations,
    [conversationId]: {
      ...conversations[conversationId],
      composer: { ...conversations[conversationId]?.composer, external },
    }
  } })
}

const updateMentions = (state, action) => {
  const { conversationId, mentions } = action.payload
  const { conversations } = state
  let composer = Object.assign({}, conversations[conversationId]?.composer || {})

  composer = {
    ...conversations[conversationId]?.composer || {},
    mentions
  }

  return updateState(state, {
    conversations: {
      ...conversations,
      [conversationId]: {
        ...conversations[conversationId],
        composer,
      }
    }
  })
}

const addAttachments = (state, action) => {
  const { conversationId, attachments, requireClean } = action
  const { conversations } = state
  let composer = Object.assign({}, conversations[conversationId]?.composer || {})

  composer = {
    ...conversations[conversationId]?.composer || {},
    attachments: requireClean ? attachments : (conversations[conversationId]?.composer?.attachments || []).concat(attachments),
    uploading: false,
  }

  const _conversations = {
    ...conversations,
    [conversationId]: {
      ...conversations[conversationId],
      composer,
    }
  }
  return updateState(state, { conversations: _conversations })
}

const removeAttachment = (state, action) => {
  const { conversationId, attachmentId } = action
  const { conversations } = state
  let composer = Object.assign({}, conversations[conversationId]?.composer || {})
  const attachments = conversations[conversationId]?.composer?.attachments.filter(attachment => attachment.id !== attachmentId)

  composer = {
    ...composer,
    attachments,
  }

  const _conversations = {
    ...conversations,
    [conversationId]: {
      ...conversations[conversationId],
      composer,
    }
  }
  return updateState(state, { conversations: _conversations })
}

const uploadingFile = (state, action) => {
  const { conversationId, value } = action
  const { conversations } = state
  let composer = Object.assign({}, conversations[conversationId]?.composer || {})

  composer = {
    ...composer,
    uploading: value,
  }

  const _conversations = {
    ...conversations,
    [conversationId]: {
      ...conversations[conversationId],
      composer,
    }
  }
  return updateState(state, { conversations: _conversations })
}

const cleanComposer = (state, action) => {
  const { conversationId } = action
  const { conversations } = state
  let composer = Object.assign({}, conversations[conversationId]?.composer || {})

  composer = {
    message: '',
    attachments: [],
    uploading: false,
  }

  const _conversations = {
    ...conversations,
    [conversationId]: {
      ...conversations[conversationId],
      composer,
    }
  }
  return updateState(state, { conversations: _conversations })
}

const setNewDirectMessage = (state, action) => {
  const { conversations } = state
  const { message } = action.payload

  if (!conversations[message.conversationId].chat) {
    return updateState(state, {})
  }

  const updatedMessages = _cloneDeep(conversations[message.conversationId].chat.messages)
  updatedMessages.unshift(message)
  return updateState(state, {
    conversations: {
      ...state.conversations,
      [message.conversationId]: {
        ...state.conversations[message.conversationId],
        chat: {
          ...state.conversations[message.conversationId].chat,
          messages: updatedMessages
        }
      }
    }
  })
}

const updateConversations = (state, action) => {
  const { newConversations } = action.payload
  return updateState(state, {
    channel: {
      ...state.channel,
      conversations: newConversations
    }
  })
}

const onToggleThreads = (state, action) => {
  const { conversationId, parentId } = action
  let threads = Object.assign({}, state.threads)

  // SE VA A CERAR EL MODAL DEL HILO, SE REMUEVE LOS MENSAJES DEL HILO
  if (state.isOpenThreads) {
    delete threads[conversationId]
  }

  return updateState( state, {
    isOpenThreads: !state.isOpenThreads,
    parentId: parentId ? parentId : '',
    threads
  })
}

const updateUserConversation = (state, action) => {
  const { users, usersInfo, index } = action.payload
  const { conversations } = state.channel
  const newConversations = [...conversations, ]
  newConversations[index] = { ...conversations[index], users, usersInfo }
  return updateState(state, {
    channel: {
      ...state.channel,
      conversations: [
        ...newConversations
      ]
    }
  })
}

const updateConversationComposer = (state, action) => {
  const { users, usersInfo, conversationId } = action.payload
  const { conversations } = state
  return updateState(state, {
    conversations:{
      ...conversations,
      [conversationId]:{
        ...conversations[conversationId],
        conversation: {
          ...conversations[conversationId].conversation,
          users,
          usersInfo
        }
      }
    }
  })
}

const updateFiltersDirect = (state, action) => {
  return updateState(state, { direct: { ...state.direct, ...action.payload } })
}

const updateSection = (state, action) => {
  const data = action.payload
  const newConversations = [...state.sections.conversations]
  let conversationIndex = newConversations.findIndex(conversation => conversation._id === data._id)
  if(conversationIndex !== -1){
    newConversations[conversationIndex] = data
    return updateState(state, {
      sections:{
        ...state.sections,
        conversations: [...newConversations]
      }
    })
  }
  return updateState(state, {
    sections: {
      conversations: [...newConversations, { ...data }],
      sectionsOrder: [...state.sections.sectionsOrder, data._id]
    }
  })
}

const removeSection = (state, action) => {
  const { sectionId } = action.payload
  const conversations = [...state.sections.conversations]
  const sectionsOrder = [...state.sections.sectionsOrder]
  const indexConversation = conversations.findIndex(conversation => conversation._id === sectionId)
  if(indexConversation !== -1){
    conversations.splice(indexConversation, 1)
  }
  return updateState(state, {
    sections: {
      conversations: [...conversations],
      sectionsOrder: sectionsOrder.filter(sect => sect !== sectionId)
    }
  })
}

const updateOrderSections = (state, action) => {
  const { sectionsOrder } = action.payload
  return updateState(state, {
    sections: {
      ...state.sections,
      sectionsOrder
    }
  })
}

const moveConversationsSectionsDirect = (state, action) => {
  const { direct, sections } = action.payload
  return updateState(state, { direct, sections })
}

const updateMessageReactions = (state, action) => {
  const { conversationId, messageId, reactions } = action.payload
  let messageIndex = state.conversations[conversationId].chat.messages.findIndex(({ _id }) => _id === messageId)
  if(messageIndex === -1){
    messageIndex = state.threads[conversationId].messages.findIndex(({ _id }) => _id === messageId)
    return updateState(state, {
      threads: {
        ...state.threads,
        [conversationId]: {
          ...state.threads[conversationId],
          messages: Object.assign([...state.threads[conversationId].messages], {
            [messageIndex]: {
              ...state.threads[conversationId].messages[messageIndex],
              reactions
            }
          })
        }
      }
    })
  }
  return updateState(state, {
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...state.conversations[conversationId],
        chat: {
          ...state.conversations[conversationId].chat,
          messages: Object.assign([...state.conversations[conversationId].chat.messages], {
            [messageIndex]: {
              ...state.conversations[conversationId].chat.messages[messageIndex],
              reactions
            }
          })
        }
      }
    }
  })
}

const setPinnedMessages = (state, action) => {
  const { conversationId, messages } = action
  return updateState(state, {
    pinned: {
      ...state.pinned,
      [conversationId]: {
        ...state.pinned[conversationId],
        messages,
        total: messages.length || 0,
      }
    }
  })
}

const updateCountPinnedMessages = (state, action) => {
  const { conversationId, count } = action
  return updateState(state, {
    pinned: {
      ...state.pinned,
      [conversationId]: {
        ...state.pinned[conversationId],
        total: (state.pinned[conversationId].total || 0) + count,
      }
    }
  })
}

const setDrafts = (state, action) => {
  const { drafts } = action
  return updateState(state,
    {
      drafts: drafts.length || 0,
    }
  )
}

const setDraftId = (state, action) => {
  const { draftIdForEdit } = action
  return updateState(state,
    {
      draftIdForEdit: draftIdForEdit,
    }
  )
}

const updateCountSavedMessages = (state, action) => {
  const { count } = action
  return updateState(state, {
    savedMessage: (state.savedMessage || 0) + count,
  })
}

const updateCountDraftMessages = (state, action) => {
  const { count } = action
  return updateState(state, {
    drafts: (state.drafts || 0) + count,
  })
}

const updateMentionsState = (state, action) => {
  const { count, type } = action.payload
  let mentions = count
  if(type === 'add') mentions = (state.mentions || 0) + count
  return updateState(state, {
    mentions
  })
}

const updateUnreadMessages = (state, action) => {
  const { conversationId, totalMessages, activeUser } = action.payload
  const isActiveUser = activeUser === conversationId
  const channels = [...state.channel.conversations]
  const direct = [...state.direct.conversations]
  const sections = [...state.sections.conversations]
  let indexChannel = channels.findIndex(conversation => conversation._id === conversationId)
  let indexDeleted
  if(indexChannel > -1) {
    channels[indexChannel].totalUnreadMessages = getNumberMessages(isActiveUser, totalMessages, channels[indexChannel].totalUnreadMessages)
    indexDeleted = channels.splice(indexChannel, 1)
    channels.unshift(indexDeleted[0])
  }
  let indexDirect = direct.findIndex(conversation => conversation._id === conversationId)
  if(indexDirect > -1){
    direct[indexDirect].totalUnreadMessages = getNumberMessages(isActiveUser, totalMessages, direct[indexDirect].totalUnreadMessages)
    indexDeleted = direct.splice(indexDirect, 1)
    direct.unshift(indexDeleted[0])
  }
  let indexSection
  let indexConversationSection
  for(const [index, section] of sections.entries()) {
    indexConversationSection = section.conversations.findIndex(conversation => conversation._id === conversationId)
    if(indexConversationSection > -1){
      indexSection = index
      break
    }
  }
  if(indexSection > -1 && indexConversationSection > -1){
    sections[indexSection].conversations[indexConversationSection].totalUnreadMessages = getNumberMessages(isActiveUser, totalMessages, sections[indexSection].conversations[indexConversationSection].totalUnreadMessages)
  }
  return updateState(state, {
    channel: {
      ...state.channel,
      conversations: channels
    },
    direct: {
      ...state.direct,
      conversations: direct
    },
    sections: {
      ...state.sections,
      conversations: sections
    }
  })
}

const getNumberMessages = (isActiveUser, totalMessages, currentMessages) => {
  return isActiveUser ? 0 : totalMessages === 0 ? totalMessages : currentMessages + totalMessages
}

export default createReducer(initialState, {
  [types.INCHAT_GET_DIRECT_CONVERSATIONS_LIST]: getDirectConversationsList,
  [types.INCHAT_GET_INFO_MAIN_MENU]: getMainMenuInfo,
  [types.INCHAT_ADD_CONVERSATIONS]: addConversation,
  [types.INCHAT_UPDATE_CHAT_STATE]: updateChatState,
  [types.INCHAT_SET_CONVERSATION_MESSAGES]: setConversationMessages,
  [types.INCHAT_SET_SCHEDULED_MESSAGES]: setScheduledMessages,
  [types.INCHAT_UPDATE_SCHEDULED_MESSAGES_VALUES]: updateScheduledMessagesValues,
  [types.INCHAT_SET_SCHEDULED_MESSAGE_TO_EDIT]: setScheduledMessageToEdit,
  [types.INCHAT_COMPOSER_EDIT_MESSAGE]: editMessage,
  [types.INCHAT_SET_NEW_DIRECT_MESSAGE]: setNewDirectMessage,
  [types.INCHAT_COMPOSER_EDIT_MENTIONS]: updateMentions,
  [types.INCHAT_COMPOSER_ADD_ATTACHMENTS]: addAttachments,
  [types.INCHAT_COMPOSER_CLEAN]: cleanComposer,
  [types.INCHAT_COMPOSER_UPLOADING_FILE]: uploadingFile,
  [types.INCHAT_UPDATE_CONVERSATIONS]: updateConversations,
  [types.INCHAT_COMPOSER_REMOVE_ATTACHMENT]: removeAttachment,
  [types.INCHAT_REMOVE_CONVERSATION]: removeConversation,
  [types.INCHAT_REMOVE_ALL_CONVERSATIONS]: removeAllConversation,
  [types.INCHAT_ON_TOGGLE_THREADS]: onToggleThreads,
  [types.INCHAT_SET_THREADS_MESSAGES]: setThreads,
  [types.INCHAT_SET_NEW_THREAD_MESSAGE]: setNewThreadMessage,
  [types.INCHAT_UPDATE_THREAD_STATE]: updateThreadState,
  [types.INCHAT_UPDATE_USERS_CONVERSATION]: updateUserConversation,
  [types.INCHAT_UPDATE_FILTERS_DIRECT]: updateFiltersDirect,
  [types.INCHAT_UPDATE_SECTIONS]: updateSection,
  [types.INCHAT_UPDATE_ORDER_SECTIONS]: updateOrderSections,
  [types.INCHAT_UPDATE_MESSAGE_REACTIONS]: updateMessageReactions,
  [types.INCHAT_REMOVE_SECTION]: removeSection,
  [types.INCHAT_MOVE_CONVERSATIONS_SECTIONS_DIRECT]: moveConversationsSectionsDirect,
  [types.INCHAT_SET_PINNED_MESSAGES]: setPinnedMessages,
  [types.INCHAT_SET_DRAFTS]: setDrafts,
  [types.INCHAT_SET_DRAFT_ID]: setDraftId,
  [types.INCHAT_MESSAGE_UPDATE_EXTERNAL]: updateMessageExternal,
  [types.INCHAT_UPDATE_COUNT_PINNED_MESSAGES]: updateCountPinnedMessages,
  [types.INCHAT_UPDATE_COUNT_SAVED_MESSAGES]: updateCountSavedMessages,
  [types.INCHAT_UPDATE_COUNT_DRAFT_MESSAGES]: updateCountDraftMessages,
  [types.INCHAT_UPDATE_COUNT_MENTIONS_REACTIONS]: updateMentionsState,
  [types.INCHAT_UPDATE_INFO_CONVERSATION_COMPOSER]: updateConversationComposer,
  [types.INCHAT_UPDATE_UNREAD_MESSAGES]: updateUnreadMessages
})
